module.exports = __webpack_public_path__ + "img/battletrip_main_mo.2e02234c.jpg";